module.exports = require('./assets/vue-directive-image-previewer.js')



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-directive-image-previewer/dist/index.js
// module id = 3tBl
// module chunks = 385